class Search {
  constructor() {
    const search = $('.search');

    // Open Search
    this.openSearch(search);

    // Close Search
    this.closeSearch(search);
  }

  openSearch(search) {
    const that = this;

    $('.js-open-search').on('click', function(e) {
      e.preventDefault();

      that.toggleOverlay(false);
      that.toggleSearch(search, false);
    });
  }

  closeSearch(search) {
    const that = this;

    $('.js-close-search').on('click', function(e) {
      e.preventDefault();

      that.toggleOverlay(true);
      that.toggleSearch(search, true);
    });
  }

  toggleOverlay(isVisible) {
    let body = $('body');

    if (isVisible) {
      body.removeClass('-search-opened');
    } else {
      body.addClass('-search-opened');
    }
  }

  toggleSearch(search, isVisible) {
    let outerWidth = $(window).outerWidth();

    if (isVisible) {
      search.removeClass('-opened');
    } else {
      search.addClass('-opened');
    }
  }
}

export default Search;
